import { PermissionType } from '@watershed/constants/permissions';
import { Teams } from '@watershed/constants/teams';
import PageContainer from '@watershed/shared-frontend/components/PageContainer';
import Redirect from '@watershed/shared-frontend/components/Redirect';
import useLocationHash from '@watershed/shared-frontend/hooks/useLocationHash';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import { learningHubBaseUrlForViewMode } from '@watershed/shared-universal/learningHubRoutes';

import LearningHubEmbed from '../../components/LearningHubEmbed';
import { useUserContext } from '../../utils/UserContext';

export const useShouldSeeLearningHubFullScreen = () =>
  useUserContext().permissions.filter(
    ({ permission }) =>
      permission !== PermissionType.AnyUser &&
      permission !== PermissionType.ViewLearningHub
  ).length === 0;

export default function Learn() {
  useOwner(Teams.Reporting);
  const hash = useLocationHash();

  // The full page view is only for users who have no permissions or only learning hub
  if (useShouldSeeLearningHubFullScreen()) {
    return (
      <Redirect
        to={`${learningHubBaseUrlForViewMode('fullPage')}#${hash}`}
        query={new URLSearchParams(window.location.search)}
      />
    );
  }

  return (
    <PageContainer>
      <LearningHubEmbed baseRoute={learningHubBaseUrlForViewMode('regular')} />
    </PageContainer>
  );
}
